import React,{ useState, useContext, useEffect } from 'react'
import { UserContext } from '../../../contexts/userProvider'
import { BiUser, BiLock, BiShield } from 'react-icons/bi'
import { Link } from 'react-router-dom'


const Redefinir = () => {
    const {  alterarSenha ,setAlert } = useContext(UserContext);
    const [login, setLogin] = useState({email: '', senha: '', senha2: ''})

    useEffect(() => {
        const hash = window.location.pathname.split('/')[2]
        setLogin(prevLogin => ({...prevLogin, hash: hash}))
    },[]);

    function handleEmailChange(event) {
        setLogin({...login, email: event.target.value})
    }
      
    function handlePasswordChange(event) {
        setLogin({...login, [event.target.name]: event.target.value})
    }

    function logIn() {
        if(login.email === '' || login.senha === '' || login.senha2 === '') {
            setAlert({visible: true, title: 'Atenção!', placeholder: 'Para redefinir a senha, preencha todos os campos!', confirm: false, type: 'warning'})
        } else if(login.senha !== login.senha2) {
            setAlert({visible: true, title: 'Atenção!', placeholder: 'As senhas não coincidem!', confirm: false, type: 'warning'})
        } else if(login.hash === undefined){
            setAlert({visible: true, title: 'Atenção!', placeholder: 'Ocorreu um erro ao redefinir a senha, entre em contato com suporte!', confirm: false, type: 'warning'})
        } else{
            delete login.senha2
            alterarSenha(login.email, login.senha, login.hash)
        }
    }


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
            {/* Header */}
            <div className="text-center mb-10">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                    <BiShield className="h-8 w-8 text-white" />
                </div>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    Redefinir Senha
                </h1>
                <p className="text-gray-600 text-lg">
                    Digite sua nova senha para acessar o sistema
                </p>
            </div>

            {/* Formulário */}
            <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-8">
                <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); logIn(); }}>
                    {/* Campo de e-mail */}
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">E-mail</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <BiUser className="h-5 w-5 text-gray-400" />
                            </div>
                            <input 
                                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                type="email" 
                                placeholder="Digite seu e-mail" 
                                value={login.email}
                                onChange={handleEmailChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Campo de nova senha */}
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Nova Senha</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <BiLock className="h-5 w-5 text-gray-400" />
                            </div>
                            <input 
                                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                type="password" 
                                name="senha"
                                placeholder="Digite sua nova senha" 
                                value={login.senha}
                                onChange={handlePasswordChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Campo de confirmação de senha */}
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Confirmar Senha</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <BiLock className="h-5 w-5 text-gray-400" />
                            </div>
                            <input 
                                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                type="password" 
                                name="senha2"
                                placeholder="Confirme sua nova senha" 
                                value={login.senha2}
                                onChange={handlePasswordChange}
                                required
                            />
                        </div>
                    </div>
                  
                    {/* Botão de alterar senha */}
                    <button 
                        type="submit"
                        className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    >
                        <span className="flex items-center justify-center">
                            Redefinir Senha
                            <BiShield className="ml-2 h-5 w-5" />
                        </span>
                    </button>

                    {/* Link de volta */}
                    <div className="text-center pt-4">
                        <Link 
                            to="/login" 
                            className="text-sm text-indigo-600 hover:text-indigo-700 font-medium transition-colors duration-200 hover:underline"
                        >
                            Voltar para o login
                        </Link>
                    </div>
                </form>
            </div>

            {/* Informação de segurança */}
            <div className="mt-6 p-4 bg-green-50 rounded-xl border border-green-100">
                <p className="text-sm text-green-700 text-center">
                    <strong>Segurança:</strong> Use uma senha forte com pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números.
                </p>
            </div>

            {/* Footer */}
            <div className="mt-8 text-center">
                <p className="text-xs text-gray-500">
                    © 2024 VoxCity Tecnologia - Sistema ERP Empresarial
                </p>
            </div>
        </div>
    </div>
  )
}

export default Redefinir
